import FW from '../fw/fw';
import Logger from '../fw/logger';


export default class UIManagement {

  #rmp;
  #chromeTimerInterval = null;

  constructor(rmp) {
    this.#rmp = rmp;
    this.#chromeTimerInterval = null;
  }

  static appendCSSForCustomIcons(icons, adOutStream, tvPlayerSkin) {
    const keys = Object.keys(icons);
    let style = '';
    keys.forEach(key => {
      const icon = icons[key];
      if (key === 'quick-rewind' || key === 'quick-forward') {
        style += '.rmp-i-' + key + '-5::before, .rmp-i-' + key + '-10::before, .rmp-i-' + key + '-30::before ' +
          '{content: none !important;}' +
          '.rmp-i-' + key + '-5, .rmp-i-' + key + '-10, .rmp-i-' + key + '-30 {';
      } else {
        style += '.rmp-i-' + key + '::before {content: none !important;}' +
          '.rmp-i-' + key + ' {';
      }
      if (tvPlayerSkin) {
        style += 'background-size: 50px !important;';
      } else {
        style += 'background-size: 30px !important;';
      }
      style += 'background-image: url("' + icon + '") !important;' +
        'background-position: center !important;' +
        'background-repeat: no-repeat !important;' +
        'font-family: none !important;' +
        'opacity: 0.9 !important;' +
        '}';
      if (!adOutStream) {
        if (key === 'quick-rewind' || key === 'quick-forward') {
          style += '.rmp-i-' + key + '-5:hover, .rmp-i-' + key + '-10:hover, .rmp-i-' + key + '-30:hover ' +
            '{opacity: 1 !important;}';
        } else {
          style += '.rmp-i-' + key + ':hover {opacity: 1 !important;}';
        }
      } else {
        style += '.rmp-i-' + key + ' {opacity: 1 !important;}';
      }
    });
    if (style) {
      let addedStyle = '';
      if (keys.includes('play')) {
        addedStyle += '.rmp-overlay-button .rmp-i-play, .rmp-mobile-central-ui .rmp-i-play';
      }
      if (keys.includes('pause')) {
        if (addedStyle) {
          addedStyle += ',';
        }
        addedStyle += '.rmp-overlay-button .rmp-i-pause, .rmp-mobile-central-ui .rmp-i-pause';
      }
      if (keys.includes('replay')) {
        if (addedStyle) {
          addedStyle += ',';
        }
        addedStyle += '.rmp-overlay-button .rmp-i-replay, .rmp-mobile-central-ui .rmp-i-replay';
      }
      addedStyle += '{ position: static !important;' +
        'left: auto !important;' +
        'top: auto !important;' +
        'height: 100% !important;' +
        '-webkit-transform: none !important;' +
        '-moz-transform: none !important;' +
        'transform: none !important;' +
        'display: block !important;' +
        'background-size: 50px !important;' +
        '}';
      addedStyle += '.rmp-module .rmp-i {' +
        'position: static !important;' +
        'left: auto !important;' +
        'top: auto !important;' +
        '-webkit-transform: none !important;' +
        '-moz-transform: none !important;' +
        'transform: none !important;' +
        'display: block !important;' +
        'height: 100% !important;' +
        '}';
      addedStyle += '.rmp-module-overlay .rmp-i-code, .rmp-module-overlay .rmp-i-copy, .rmp-module-overlay .rmp-i-link {width: 30px !important; height: 30px !important;}';
      addedStyle += 'google-cast-launcher {opacity: 0.9 !important;}';
      addedStyle += 'google-cast-launcher:hover {opacity: 1 !important;}';
      FW.appendStyle(style + addedStyle);
    }
  }

  #checkResetTimer() {
    let resetTimer = false;
    if (this.#rmp.forceResetTimer) {
      resetTimer = true;
    }
    if (this.#rmp.adOnStage) {
      // if linear ad on stage and ad is paused - do not autohide
      if (this.#rmp.adLinear && this.#rmp.adPaused) {
        resetTimer = true;
      } else if (!this.#rmp.adLinear && this.#rmp.paused) {
        // if non-linear ad on stage and content is paused - do not autohide
        resetTimer = true;
      }
    } else {
      // if no ads on stage and content is paused - do not autohide
      if (this.#rmp.paused) {
        resetTimer = true;
      }
    }
    return resetTimer;
  }

  #resetTimer() {
    window.clearInterval(this.#chromeTimerInterval);
    this.#chromeTimerInterval = window.setInterval(() => {
      if (this.#checkResetTimer()) {
        this.#resetTimer();
        return;
      }
      this.hideChrome();
    }, this.#rmp.delayToFade);
  }

  #prepForFullWindowSkin() {
    if (this.#rmp.fullWindowSkin) {
      this.#rmp.iframeMode = true;
      FW.appendStyle('html, body { height: 100%; width: 100%; background-color: #000; overflow: hidden; margin: 0; padding: 0;}');
    }
  }

  hideChrome() {
    this.#rmp.dom.container.classList.replace('rmp-chrome', 'rmp-no-chrome');
  }

  showChrome() {
    this.#rmp.dom.container.classList.replace('rmp-no-chrome', 'rmp-chrome');
    this.#resetTimer();
  }

  showCentralPlay() {
    Logger.print('info', 'show central play button');
    if (this.#rmp.isMobile) {
      this.#rmp.dom.centralMobileUI.classList.add('rmp-mobile-show-play');
    } else {
      FW.fadeIn(this.#rmp.dom.overlayButton);
    }
    this.showChrome();
  }

  hideCentralPlay() {
    Logger.print('info', 'hide central play button');
    if (this.#rmp.isMobile) {
      this.#rmp.dom.centralMobileUI.classList.remove('rmp-mobile-show-play');
    } else {
      FW.fadeOut(this.#rmp.dom.overlayButton);
    }
  }

  showLoadingSpin() {
    if (!this.#rmp.waitingUI) {
      Logger.print('info', 'show loading spinner');
      this.#rmp.dom.container.classList.add('rmp-waiting');
      FW.fadeIn(this.#rmp.dom.loadingSpin);
    }
  }

  hideLoadingSpin() {
    if (this.#rmp.waitingUI) {
      Logger.print('info', 'hide loading spinner');
      this.#rmp.dom.container.classList.remove('rmp-waiting');
      FW.fadeOut(this.#rmp.dom.loadingSpin);
    }
  }

  hideControlsUI() {
    this.#rmp.dom.container.classList.add('rmp-hide-controls');
    this.#rmp.innerControls = false;
  }

  showControlsUI() {
    this.#rmp.dom.container.classList.remove('rmp-hide-controls');
    this.#rmp.innerControls = true;
    this.showChrome();
  }

  restorePlayUI() {
    this.#rmp.dom.playPause.classList.replace('rmp-i-pause', 'rmp-i-play');
    FW.setText(this.#rmp.dom.playPauseHint, this.#rmp.labels.hint.play + ' (k)');
    if (this.#rmp.isMobile) {
      this.#rmp.dom.centralMobileUIIcon.classList.replace('rmp-i-pause', 'rmp-i-play');
    }
    this.showCentralPlay();
    this.#rmp.showPoster();
    this.#rmp.rmpUIManagement.showChrome();
  }

  appendContentTitle() {
    this.#rmp.dom.contentTitleArea = FW.createElement('div', 'rmp-title-area');
    this.#rmp.dom.contentTitle = FW.createElement('div', 'rmp-title', null, this.#rmp.rtl);
    this.#rmp.dom.contentTitle.innerHTML = this.#rmp.contentMetadata.title;
    this.#rmp.dom.contentTitle.setAttribute('title', this.#rmp.contentMetadata.title);
    this.#rmp.dom.contentTitleArea.appendChild(this.#rmp.dom.contentTitle);
    this.#rmp.dom.container.classList.add('rmp-title-ui');
    if (this.#rmp.dom.container && this.#rmp.dom.controlBar) {
      FW.insertBefore(this.#rmp.dom.container, this.#rmp.dom.contentTitleArea, this.#rmp.dom.content.nextSibling);
    }
  }

  appendContentDescription() {
    this.#rmp.dom.description = FW.createElement('div', 'rmp-description', null, this.#rmp.rtl);
    this.#rmp.dom.description.innerHTML = this.#rmp.contentMetadata.description;
    this.#rmp.dom.container.classList.add('rmp-title-description-ui');
    this.#rmp.dom.contentTitleArea.appendChild(this.#rmp.dom.description);
  }

  prepareLiveUI() {
    this.#rmp.isVod = false;
    this.#rmp.isLive = true;
    if (this.#rmp.ads) {
      this.#rmp.adTagReloadOnEnded = false;
    }
    this.#rmp.dom.container.classList.add('rmp-live');
    FW.setText(this.#rmp.dom.timeElapsedText, this.#rmp.labels.hint.live);
  }

  static appendCSSForNativeCCRendering() {
    let style = '';
    style += '.rmp-chrome.rmp-s1 video.rmp-video::-webkit-media-text-track-container {transform: translateY(-48px);}';
    style += '.rmp-no-chrome.rmp-s1 video.rmp-video::-webkit-media-text-track-container {transform: translateY(0);}';
    style += '.rmp-chrome.rmp-s2 video.rmp-video::-webkit-media-text-track-container {transform: translateY(-54px);}';
    style += '.rmp-no-chrome.rmp-s2 video.rmp-video::-webkit-media-text-track-container {transform: translateY(0);}';
    style += 'video.rmp-video::-webkit-media-text-track-container {transition-property: transform;transition-duration: 0.4s;transition-timing-function: ease-in;}';
    FW.appendStyle(style);
  }

  prepareSkin() {
    let tvStyle = 'html, body { height: 100%; width: 100%; background-color: #000; overflow: hidden; margin: 0; padding: 0;}';
    switch (this.#rmp.skin) {
      case 's1':
        this.#prepForFullWindowSkin();
        this.#rmp.dom.container.classList.add('rmp-s1');
        break;
      case 's2':
        this.#prepForFullWindowSkin();
        this.#rmp.dom.container.classList.add('rmp-s2');
        break;
      case 'tv':
        this.#rmp.tvPlayerSkin = true;
        this.#rmp.skin = 's2';
        this.#rmp.iconsSet = 'font-awesome';
        this.#rmp.iframeMode = true;
        this.#rmp.hideFullscreen = true;
        this.#rmp.hideVolume = true;
        // hide volume + quality
        tvStyle += '.rmp-quality {display: none !important}';
        this.#rmp.quickForward = 10;
        this.#rmp.quickRewind = 10;
        this.#rmp.hideExternalPlayerLabels = true;
        this.#rmp.isMobile = false;
        this.#rmp.dom.container.classList.add('rmp-s2', 'rmp-tv');
        FW.appendStyle(tvStyle);
        break;
      case 'outstream':
        this.#rmp.skin = 's2';
        this.#rmp.adShowRemainingTime = true;
        this.#rmp.dom.container.classList.add('rmp-s2', 'rmp-outstream');
        break;
      default:
        this.#rmp.skin = 's1';
        this.#prepForFullWindowSkin();
        this.#rmp.dom.container.classList.add('rmp-s1');
        break;
    }
    if (this.#rmp.iconsSet === 'material') {
      this.#rmp.dom.container.classList.add('rmp-font-material');
    } else {
      this.#rmp.dom.container.classList.add('rmp-font-awesome');
    }
    let flipStyle = '';
    if (typeof this.#rmp.flipVideo.x === 'number' &&
      typeof this.#rmp.flipVideo.y === 'number' &&
      typeof this.#rmp.flipVideo.z === 'number' &&
      (this.#rmp.flipVideo.x !== 0 || this.#rmp.flipVideo.y !== 0 || this.#rmp.flipVideo.z !== 0)) {
      flipStyle = '#' + this.#rmp.id +
        ' .rmp-video { transform: rotateX(' + this.#rmp.flipVideo.x +
        'deg) rotateY(' + this.#rmp.flipVideo.y + 'deg) rotateZ(' + this.#rmp.flipVideo.z + 'deg) }';
    }
    if (flipStyle) {
      FW.appendStyle(flipStyle);
    }
  }

  destroy() {
    window.clearInterval(this.#chromeTimerInterval);
  }

}
